"use strict"

document.addEventListener("DOMContentLoaded", () => {
  try {
    initPortfolioSlider();
    initTestimonialSlider();
    initProjectSlider();
    initServiceHeroSliders();
    initTimelineSlider();
    initBlogShowcase();
    initFAQ();
    initAboutIntro();
    initPortfolioItems();
    initProcessAnimation();
    initMastheadDrawer();
    initServiceTypes();
    initContactForm();
    initFilter();
    initScrollTo();
    initModals();
  } catch (err) {
    console.error(err);
  }
});

document.addEventListener("keydown", detectTabNavigation);

function initHeroSlider() {
  const slider = new Swiper(".HeroSlider", {
    speed: 500,
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  });
}

function initPortfolioSlider() {
  const slider = new Swiper(".PortfolioSlider", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    slideToClickedSlide: true,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next"
    },
    pagination: {
      el: ".swiper-pagination-portfolio",
      clickable: true
    },
    breakpointsInverse: true,
    breakpoints: {
      0: {
        slidesPerView: 1
      },
    }
  });
}

function initTestimonialSlider() {
  const slider = new Swiper(".TestimonialSlider", {
    speed: 500,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: ".swiper-pagination-testimonials",
      clickable: true
    }
  });
}

function initGallerySliders() {
  const imageSlider = new Swiper(".GalleryImageSlider", {
    // loop: true,
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    breakpointsInverse: true,
    navigation: {
      prevEl: ".swiper-gallery-button-prev",
      nextEl: ".swiper-gallery-button-next"
    },

  });
}

function initProjectSlider() {
  const slider = new Swiper(".ProjectSlider", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    centeredSlides: true,
    slidesPerView: 3,
    slideToClickedSlide: true,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpointsInverse: true,
    breakpoints: {
      1: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 3,
        autoplay: false
      }
    }
  });
}

function initServiceHeroSliders() {
  const imgSliderContainer = document.querySelector(".ServiceHeroImageSlider");
  const titleSliderContainer = document.querySelector(".ServiceHeroTitleSlider");

  if (imgSliderContainer && titleSliderContainer) {
    const imgSlider = new Swiper(imgSliderContainer, {
      loop: true,
      slidesPerView: 1,
      allowTouchMove: false
    });

    const titleSlider = new Swiper(titleSliderContainer, {
      loop: true,
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      }
    });

    titleSlider.controller.control = imgSlider;
  }
}

function initBlogShowcase() {
  const showcaseSection = document.querySelector("#sect-blog-showcase");
  if (showcaseSection) {
    const bigBlogImage = showcaseSection.querySelector(".ShowcaseBlog .ShowcaseBlog__ImageBlock");
    const topSmallBlog = showcaseSection.querySelector(".ShowcaseBlog--Flat");
    const topSmallBlogImage = showcaseSection.querySelector(".ShowcaseBlog--Flat .ShowcaseBlog__ImageBlock");

    const calculateGapPx = () => {
      return `${bigBlogImage.getBoundingClientRect().height - topSmallBlogImage.getBoundingClientRect().height * 2}px`;
    }

    const setSmallBlogGap = () => {
      topSmallBlog.style.marginBottom = calculateGapPx();
    }

    setSmallBlogGap();
    window.addEventListener("resize", debounce(setSmallBlogGap));
  }
}

function initFAQ() {
  const toggle = document.querySelector(".FAQNavToggle");
  const tabs = document.querySelectorAll(".FAQNav__Button");
  const topics = document.querySelectorAll(".FAQTopic");
  const questions = document.querySelectorAll(".FAQ");

  if (toggle) {
    const tglIcon = toggle.querySelector("i");
    toggle.addEventListener("click", () => {
      toggle.classList.toggle("-isActive");
      tglIcon.classList.toggle("icon-chevron-down");
      tglIcon.classList.toggle("icon-chevron-up");
    });

    window.addEventListener("click", e => {
      if (!e.target.closest(".FAQNavToggle") && !e.target.classList.contains("FAQNav")) {
        toggle.classList.remove("-isActive");
        tglIcon.classList.remove("icon-chevron-up");
        tglIcon.classList.add("icon-chevron-down");
      }
    });
  }

  if (tabs.length && topics.length ) {
    tabs.forEach(tab => {
      tab.addEventListener("click", activateTab);
    });
  }

  function activateTab(e) {
    tabs.forEach(tab => {
      if (e.currentTarget === tab) {
        tab.closest(".FAQNav__Item").classList.add("-isActive");
      } else {
        tab.closest(".FAQNav__Item").classList.remove("-isActive");
      }
    });

    topics.forEach(topic => {
      if (e.currentTarget.dataset.targetId === topic.id) {
        topic.classList.add("-isActive");
      } else {
        closeTopic(topic);
      }
    });
  }

  function toggleQuestion(e) {
    const question = e.currentTarget;
    if (question.classList.contains("-isActive")) {
      collapseQuestion(question);
    } else {
      expandQuestion(question);
    }
  }

  function expandQuestion(question) {
    const textBlock = question.querySelector(".TextBlock");
    const icon = question.querySelector(".FAQ__IconBlock i");

    question.classList.add("-isActive");
    icon.className = "icon-minus";
    textBlock.style.height = `${textBlock.scrollHeight}px`;
  }

  function collapseQuestion(question) {
    const textBlock = question.querySelector(".TextBlock");
    const icon = question.querySelector(".FAQ__IconBlock i");

    question.classList.remove("-isActive");
    icon.className = "icon-plus";
    textBlock.style.height = `0`;
  }

  function closeTopic(topic) {
    topic.querySelectorAll(".FAQ").forEach(collapseQuestion);
    topic.classList.remove("-isActive");
  }
}

function initAboutIntro() {
  const introBlock = document.querySelector("#sect-about-intro");
  let background = null;
  let featuresBlock = null;

  if (introBlock) {
    background = introBlock.querySelector(".AboutIntroBackground");
    featuresBlock = introBlock.querySelector(".AboutFeaturesBlock");
  }

  if (background && featuresBlock) {
    setAboutBgHeight();
    window.addEventListener("resize", debounce(setAboutBgHeight));
  }

  function setAboutBgHeight() {
    background.style.height = `${introBlock.getBoundingClientRect().height - (featuresBlock.getBoundingClientRect().height / (window.innerWidth < 992 ? 1 : 2))}px`;
  }
}

function initPortfolioItems() {
  const items = document.querySelectorAll(".PortfolioItem");

  if (items.length) {
    items.forEach(item => {
      const content = item.querySelector(".PortfolioItem__ContentBlock");
      let maxH;
      let autoH;

      item.activate = function() {
        calculateHeights();
        content.style.height = `${autoH}px`;
        window.addEventListener("resize", debounce(calculateHeights));
        
        item.addEventListener("mouseenter", () => {
          content.style.height = `${maxH}px`;
        });
        
        item.addEventListener("mouseleave", () => {
          content.style.height = `${autoH}px`;
        });
      }
      
      window.addEventListener("load", () => {
        if (item.closest(".FilterItem").classList.contains("-isActive")) {
          item.activate();
        }
      });

      function calculateHeights() {
        maxH = item.getBoundingClientRect().height;
        content.style.height = "";
        autoH = content.scrollHeight;
      }
    });
  }
}


function initProcessAnimation() {
  const sect = document.querySelector("#sect-process");
  const hor = document.querySelector(".ProcessLine--Hor");
  const vert1 = document.querySelector(".ProcessLine--Vert1");
  const vert2 = document.querySelector(".ProcessLine--Vert2");

  if (sect && hor && vert1 && vert2) {
    const horAnim = gsap.to(hor, {
      scrollTrigger: {
        trigger: sect,
        start: "top 50%",
        end: "bottom bottom",
        scrub: true,
      },
      width: `100%`
    });
    
    const vert1Anim = gsap.to(vert1, {
      scrollTrigger: {
        trigger: sect,
        start: "top 50%",
        end: "bottom bottom",
        scrub: true,
      },
      height: `calc(100% - 3.75rem)`
    });

    const vert2Anim = gsap.to(vert2, {
      scrollTrigger: {
        trigger: sect,
        start: "top 50%",
        end: "bottom bottom",
        scrub: true,
      },
      height: `calc(100% - 3.75rem)`
    });
  }
}

function initMastheadDrawer() {
  const masthead = document.querySelector(".Masthead");
  const toggle = document.querySelector(".MastheadDrawerToggle");
  const toggleIcon = toggle.querySelector("i");
  const backdrop = document.querySelector(".MastheadBackdrop");

  if (masthead && toggle && toggleIcon && backdrop) {
    toggle.addEventListener("click", toggleDrawer);

    backdrop.addEventListener("click", toggleDrawer);

    function toggleDrawer() {
      masthead.classList.toggle("-isExpanded");
      toggleIcon.classList.toggle("icon-menu");
      toggleIcon.classList.toggle("icon-cross");
    }
  }
}

function initServiceTypes() {
  const tabs = document.querySelectorAll(".ServiceTypeTab__Button");
  const types = document.querySelectorAll(".ServiceType");
  if (tabs.length && types.length) {
    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => {
          if (t === tab) {
            t.classList.add("-isActive");
          } else {
            t.classList.remove("-isActive");
          }
        });
        types.forEach(type => {
          if (type.id === tab.dataset.target) {
            type.classList.add("-isActive");
          } else {
            type.classList.remove("-isActive");
          }
        });
      });
    });
  }
}

function initContactForm() {
  const form = document.querySelector("#contact-form");
  let inputs;

  if (!form) return;

  inputs = form.querySelectorAll(".-validate");

  if (!inputs.length) return;

  inputs.forEach(input => {
    const alertEl = input.closest(".ContactFormInputBlock").querySelector(".ContactFormAlert");
    const alertMsgEl = alertEl.querySelector(".ContactFormAlertMessage");

    if (!alertEl || !alertMsgEl) return;
    
    input.addEventListener("invalid", e => {
      e.preventDefault();
      showAlert();
    });

    input.addEventListener("blur", e => {
      if (input.validationMessage) {
        showAlert();
      }
    });

    input.addEventListener("focus", e => {
      hideAlert();
    }); 

    input.addEventListener("input", e => {
      hideAlert();
    });

    function showAlert() {
      alertEl.classList.add("-isActive");
      alertMsgEl.innerText = input.validationMessage;
    }
  
    function hideAlert() {
      alertEl.classList.remove("-isActive");
      alertMsgEl.innerText = "";
    }
  })
}

function initFilter() {
  if (document.body.id === "page-faq") return;

  const masthead = document.querySelector(".Masthead");
  const navBlock = document.querySelector(".FAQNavBlock");
  const nav = document.querySelector(".FAQNav");
  const toggle = document.querySelector(".FAQNavToggle");
  const btns = document.querySelectorAll(".FAQNav__Button");
  const container = document.querySelector(".FilterContainer");
  const items = document.querySelectorAll(".FilterItem");
  const moreBtn = document.querySelector(".Pagination .Button--GhostPrimary");
  const pageList = document.querySelector(".PaginationPages");

  let initialLoad = true;

  if (!toggle || !navBlock || !btns.length || !items.length || !moreBtn || !pageList) return;

  let currCategory = null;

  let itemsPerPage;
  if (document.body.id === "page-portfolio") {
    itemsPerPage = 24;
  } else if (document.body.id === "page-blog") {
    itemsPerPage = 4;
  }

  let currPage;
  let filteredItems = filterCategoryItems();
  let pageListLinks = [];
  let filteredPageCount;

  generatePageList();
  goToPage(1);
  moreBtn.addEventListener("click", showMore);
  btns.forEach(btn=> {
    btn.addEventListener("click", changeCategory);
  });
  
  function filterCategoryItems() {
    if (currCategory === null) return Array.from(items);
    return Array.from(items).filter(item => {
      return item.dataset.category === currCategory;
    });
  }

  function generatePageList() {
    clearPageList();
    filteredPageCount = Math.ceil(filteredItems.length / itemsPerPage);
    for (let i = 0; i < filteredPageCount; i++) {
      const pageItem = document.createElement("li");
      const pageLink = document.createElement("a");

      pageItem.className = "PaginationPages__Item";
      
      pageLink.innerText = i + 1;
      pageLink.dataset.page = i + 1;
      pageLink.href = "javascript:void(0)";
      pageLink.className = "PaginationPages__Link";
      pageLink.addEventListener("click", e => {
        goToPage(+e.currentTarget.dataset.page)
      });

      pageItem.appendChild(pageLink);

      pageList.appendChild(pageItem);

      pageListLinks.push(pageLink);
    }
  }

  function clearPageList() {
    pageList.innerHTML = "";
    pageListLinks = [];
  }

  function goToPage(n) {
    if (initialLoad) {
      initialLoad = false;
      _goToPage(n);
    } else {
      fadeOut();
      container.addEventListener("transitionend", () => {
        _goToPage(n);
        window.scrollTo({
          top: window.pageYOffset + navBlock.getBoundingClientRect().top - masthead.offsetHeight,
          behavior: "smooth"
        });
        fadeIn();
      }, {once: true});
    }

    function _goToPage(n) {
      for (let i = 0; i < pageListLinks.length; i++) {
        if (+pageListLinks[i].dataset.page === n) {
          pageListLinks[i].classList.add("-isActive");
        } else {
          pageListLinks[i].classList.remove("-isActive");
        }
      }
  
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove("-isActive");
      }
      
      for (let i = (n - 1) * itemsPerPage; i < filteredItems.length; i++) {
        if (i < n * itemsPerPage) {
          filteredItems[i].classList.add("-isActive");
          const portfolioItem = filteredItems[i].querySelector(".PortfolioItem");
          if (portfolioItem) {
            portfolioItem.activate();
          }
        }
      }
  
      currPage = n;
    }
  }

  function showMore() {
    fadeOut();

    container.addEventListener("transitionend", () => {
      const availableItems = filteredItems.slice(currPage * itemsPerPage);
      let newlyShownCounter = 0;
      for (let item of availableItems) {
        if (newlyShownCounter >= itemsPerPage) break;
        item.classList.add("-isActive");

        const portfolioItem = item.querySelector(".PortfolioItem");
        if (portfolioItem) {
          portfolioItem.activate();
        }

        newlyShownCounter++;
      }
      currPage++;

      fadeIn();
    }, {once: true});
  }

  function changeCategory(e) {
    const categoryData = e.currentTarget.dataset.category;
    if (categoryData === "") {
      currCategory = null;
    } else {
      currCategory = categoryData;
    }

    btns.forEach(btn => {
      const tglSpan = toggle.querySelector("span");
      if (btn === e.currentTarget) {
        btn.closest(".FAQNav__Item").classList.add("-isActive");
        tglSpan.textContent = btn.textContent.trim();
      } else {
        btn.closest(".FAQNav__Item").classList.remove("-isActive");
      }
    });
    
    filteredItems = filterCategoryItems();
    generatePageList();
    goToPage(1);
  }

  function fadeOut() {
    container.classList.add("-fade");
  }

  function fadeIn() {
    container.classList.remove("-fade");
  }
}

function debounce(cb) {
  let timeout = null;
  return function(...args) {
    if (timeout) cancelAnimationFrame(timeout);
    timeout = requestAnimationFrame(cb.bind(this, ...args));
  }
}

function initScrollTo() {
  const btns = document.querySelectorAll(".ScrollToButton");
  if (btns.length) {
    btns.forEach(btn => {
      btn.addEventListener("click", () => {
        window.location.hash = "";
        if (window.innerWidth < 992 && btn.dataset.scrolltoMobile) {
          window.location.hash = btn.dataset.scrolltoMobile;
        } else if (window.innerWidth >= 992 && btn.dataset.scrolltoDesktop) {
          window.location.hash = btn.dataset.scrolltoDesktop;
        }
      });
    });
  }
}

function detectTabNavigation(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', detectTabNavigation);
  }
}


function initModals() {
  const triggers = document.querySelectorAll(".ModalTrigger");
  triggers.forEach(trigger => {
    const modal = document.getElementById(trigger.dataset.modal);
    const modalClose = modal.querySelector(".ModalClose");
    const modalCloseImage = modal.querySelector(".ModalClose__Image");

    trigger.addEventListener("click", function() {
      modal.classList.add("active");
      initGallerySliders();
    });

    modal.addEventListener("click", function(e) {
      if (e.target === modal || e.target === modalClose) {
        modal.classList.remove("active");
      }
    });
    modal.addEventListener("click", function(e) {
      if (e.target === modal || e.target === modalCloseImage) {
        modal.classList.remove("active");
      }
    });
  });
}

const initTimelineSlider = () => {
  const slider = new Swiper("#timeline-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (i, className) {
        const title = this.slides[i].dataset.title;
        return (`
          <button class="${className}">
            <div class="swiper-dot-1">
              <div class="swiper-dot-2">
                <div class="swiper-dot-3">
                  <span class="swiper-bullet-text">
                    ${title}
                  </span>
                </div>
              </div>
            </div>
          </button>`
        )
      }
    },
  });

  if (slider.el) {
    const bullets = slider.el.querySelectorAll(".swiper-pagination-bullet");

    if (bullets) {
      bullets.forEach(bullet => {
        bullet.addEventListener("mouseover", () => {
          bullet.click();
        })
      });
    }
  }
}
